import { useCallback } from 'react';
import LogRocket from 'logrocket';

const logRocketBookedFreightShipmentEventName = 'BOOKED_FREIGHT_SHIPMENT';

export type BookedFreightShipmentSource = 'wizard' | 'rate_card';

export const useTrackBookedFreightShipmentClick = (): ((source: BookedFreightShipmentSource) => void) => {
  return useCallback((source: BookedFreightShipmentSource) => {
    const environment = process.env.NODE_ENV || 'development';
    LogRocket.track(logRocketBookedFreightShipmentEventName, {
      env: environment,
      source,
    });
  }, []);
};
